var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostArrowTobottomActived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.8144L20.2238 7.14047C20.3949 6.95992 20.6798 6.9526 20.8599 7.12412C21.0401 7.29564 21.0474 7.58104 20.8762 7.76158L12.3262 16.7796C12.1488 16.9667 11.8512 16.9667 11.6737 16.7796L3.12375 7.76158C2.95258 7.58103 2.95988 7.29563 3.14007 7.12412C3.32025 6.9526 3.60508 6.95992 3.77625 7.14046L12 15.8144Z",
    fill: "#B05B19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostArrowTobottomActived);
export default __webpack_public_path__ + "static/media/cost_arrow_tobottom_actived.ad0057f17f09c6e2dcf7b1ae768ee7ca.svg";
export { ForwardRef as ReactComponent };